// extracted by mini-css-extract-plugin
export default {"p_policy":"PrivacyPolicy_p_policy__E22uT"};